import { emailSchema } from 'models/input/validationSchema';
import { translate } from 'support/translate';
import LoginInputField from 'components/common/input/LoginInputField';

export default class EmailInputField extends LoginInputField {
  override _init() {
    this.patch({
      placeholderText: translate('account.login.emailPlaceholderLabel'),
      showChangeText: true,
      schema: emailSchema,
      errorType: translate('account.login.emailErrorType'),
      errorMessage: translate('account.login.invalidEmailError'),
    });
  }

  override _handleEnter() {
    this.signal('$emailInputSelected', this);
  }
}
